import React, { useMemo, useState } from 'react'
import { Text, Flex, Button, Checkbox } from '@leverege/ui-elements'
import { connect } from 'react-redux'
import { groupPermissions } from './Util'
import GroupPermissionList from './GroupPermissionList'

import EditPermissionsDialog from './EditPermissionsDialog'

function PermissionList( props ) {
  const { permissions = [], modules, editable, onChange, role, eventData } = props
  const [ showAdd, setShowAdd ] = useState( false )
  // const [ selected, setSelected ] = useState( permissions )
  const selected = { } 
  permissions.forEach( ( s ) => { 
    if ( s.remove !== true ) {
      selected[s.id] = s 
    }
  } )
  const group = useMemo( ( ) => { 
    return groupPermissions( permissions, modules, true )
  }, [ permissions, modules ] )

  const onAddOpen = ( ) => { setShowAdd( true ) }
  const onAddClose = ( ) => { setShowAdd( false ) }
  const onSelectPermissions = ( selected ) => {
    // const n = permissions.filter( ( p ) => { return selected[p.id] == null } )
    onChange( {
      value : [ /* ...n,*/ ...Object.values( selected ) ],
      data : eventData
    } )
    setShowAdd( false )
  }

  const onToggle = ( event ) => {
    const n = permissions.map( ( p ) => { 
      if ( p.id === event.data.id ) {
        const n = { ...p }
        if ( event.value ) {
          delete n.remove
        } else {
          n.remove = true
        }
        return n
      }
      return p
    } )
    onChange( {
      value : n,
      data : eventData
    } )
  }
 
  return (
    <div>
      <Flex variant="rowS" justify="space-between">
        <Text variant="subtitle">Permissions</Text>
        { editable !== false && <Button variant="secondarySmall" onClick={onAddOpen}>Edit</Button> }
      </Flex>
      <GroupPermissionList 
        groups={group} 
        selected={selected} 
        onSelect={onToggle} 
        itemProps={{ editable }}/>

      <EditPermissionsDialog 
        show={showAdd} 
        role={role} 
        permissions={permissions} 
        onClose={onAddClose} 
        onSelect={onSelectPermissions} />
    </div>
  )
}

export default connect( ( state ) => {
  return {
    modules : state.modules
  } 
} )( PermissionList )
